"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _uuid = _interopRequireDefault(require("uuid"));

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class ThreadOwnerBubbles extends _react.Component {
  render() {
    const {
      admin,
      members
    } = this.props;
    const assignedUsers = members ? members.filter(member => member.isAssigned).map(member => admin === null || admin === void 0 ? void 0 : admin.find(a => a.id == member.userId)) : [];

    if (!assignedUsers) {
      return /*#__PURE__*/_react.default.createElement("div", null);
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "thread-assignee-container"
    }, assignedUsers.map(user => {
      if (!user) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: (0, _uuid.default)()
        });
      }

      const {
        firstName,
        lastName
      } = user;
      const initials = firstName && lastName ? firstName[0] + lastName[0] + lastName[1] : firstName ? firstName.substring(0, 3) : lastName ? lastName.substring(0, 3) : 'N/A';
      return /*#__PURE__*/_react.default.createElement("div", {
        key: `thread_owner_bubble_${user.id}`,
        className: "thread-assignee-bubble"
      }, /*#__PURE__*/_react.default.createElement("span", null, initials.toUpperCase()));
    }));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  admin: selectors.getAdmin
});

var _default = (0, _reactRedux.connect)(mapStateToProps)(ThreadOwnerBubbles);

exports.default = _default;